import React, { useEffect, useState } from "react";
import Input from "../../../../Input";
import Select from "../../../../Select";
import { StockService } from "../../../../../services/StockService";

const toId = (value) => {
  const id = parseInt(value);
  return Number.isNaN(id) ? 0 : id;
};

export const locationError = (state) => {
  if (!toId(state.concessionId)) return "Select the concession for this species.";
  if (!toId(state.compartmentId)) return "Select the compartment for this species.";
  return null;
};

export const locationPayload = (state) => ({
  volume: parseFloat(state.volume) || 0,
  concessionId: toId(state.concessionId),
  compartmentId: toId(state.compartmentId),
});

const SpeciesLocationFields = ({ state, setState, disabled }) => {
  const [concessions, setConcessions] = useState([]);

  useEffect(() => {
    StockService.GetAllConcessions().then((res) => {
      setConcessions(
        (res || []).map((c) => ({
          ...c,
          value: c.concessionId,
          label: c.concessionName,
        }))
      );
    });
  }, []);

  const selectedConcession = concessions.find((c) => c.concessionId === toId(state.concessionId));
  const compartments = (selectedConcession?.compartments || []).map((c) => ({
    value: c.compartmentId,
    label: c.compartmentName,
  }));

  const handleVolume = (e) => {
    const { value } = e.target;
    setState((s) => ({ ...s, volume: value }));
  };
  const handleConcession = (e) => {
    const concessionId = toId(e.target.value);
    setState((s) => ({ ...s, concessionId, compartmentId: 0 }));
  };
  const handleCompartment = (e) => {
    const compartmentId = toId(e.target.value);
    setState((s) => ({ ...s, compartmentId }));
  };

  return (
    <>
      <label className="block">
        <span className="block mb-3 text-gray-700 text-md">Volume (m³)</span>
        <Input
          placeholder="Volume"
          type="number"
          step="any"
          min="0"
          disabled={disabled}
          value={state.volume}
          onChange={handleVolume}
          required
          id="volume"
        />
      </label>
      <label className="block">
        <span className="block mb-3 text-gray-700 text-md">Concession</span>
        <Select
          disabled={disabled}
          value={state.concessionId || ""}
          options={concessions}
          onChange={handleConcession}
          required
          id="concessionId"
        />
      </label>
      <label className="block">
        <span className="block mb-3 text-gray-700 text-md">Compartment</span>
        <Select
          disabled={disabled || !state.concessionId}
          value={state.compartmentId || ""}
          options={compartments}
          onChange={handleCompartment}
          required={compartments.length > 0}
          id="compartmentId"
        />
      </label>
    </>
  );
};

export default SpeciesLocationFields;
